import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import debounce from 'lodash.debounce';

export default class QuantitySelect extends Component {
    static propTypes = {
        value: PropTypes.number,
        maxValue: PropTypes.number,
        updateAmountFunction: PropTypes.func,
        shouldQuantityChange: PropTypes.bool,
    };

    static defaultProps = {
        value: 1,
        maxValue: null,
        updateAmountFunction: null,
        shouldQuantityChange: false,
    };

    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value,
            minValue: 1,
            changeCounter: 0,
        };

        this.updateAmount = debounce(this.debounceFunction, 500);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.props.value) {
            this.setState({value: nextProps.value});
        }
    }

    debounceFunction = () => {
        this.props.updateAmountFunction(this.state.changeCounter);
        this.setState({changeCounter: 0});
    };

    handleChange = (change) => {
        const maxValue = this.props.maxValue || 10000;
        const value = this.state.value;

        if ((maxValue === null || value + change < maxValue) && value + change > 0) {
            this.setState({
                value: this.state.value + change,
                changeCounter: this.state.changeCounter + change,
            }, () => {
                // We use the QuantitySelect in three places
                // and it only needs to do a API call in one. This is for checking that.
                if (this.props.shouldQuantityChange && this.state.changeCounter) {
                    this.updateAmount();
                }
            });
        }
    };

    handleRawInput = (e) => {
        const newValue = parseInt(e.target.value, 10);
        if (Number.isInteger(newValue)) {
            const change = newValue - this.state.value;
            this.handleChange(change);
        }
    };

    render() {
        const incrementClassNames = classNames(
            'quantity-select__controls__increment',
            {disabled: this.props.maxValue !== null && this.state.value >= this.props.maxValue},
        );

        const decrementClassNames = classNames(
            'quantity-select__controls__decrement',
            {disabled: this.state.value <= this.state.minValue},
        );

        return (
            <div className="quantity-select">
                <div className="quantity-select__input">
                    <input
                        id="id_quantity"
                        min={this.state.minValue}
                        max={this.props.maxValue || 10000}
                        name="quantity"
                        type="number"
                        value={this.state.value}
                        onChange={this.handleRawInput}
                    />
                </div>
                <div className="quantity-select__controls">
                    <div className={incrementClassNames} onClick={() => this.handleChange(1)} />
                    <div className={decrementClassNames} onClick={() => this.handleChange(-1)} />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/QuantitySelect.js